module.exports = __webpack_public_path__ + "7399b0b49672a06d303024f21247ba5b.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_5@2x.png
// module id = 215
// module chunks = 1